import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  content: css`
    @media (min-width: 800px) {
      padding-bottom: 24px;
    }
  `,
  section: css`
    border-top: 1px solid ${colors.silver};
    display: flex;
    flex-direction: row;
    gap: 40px;
    padding: 21px 16px 28px 16px;
    @media (min-width: 800px) {
      padding: 24px;
    }
  `,
  footerSpacing: css`
    @media (min-width: 800px) {
      padding-bottom: 24px;
    }
  `,
  buttonContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    width: 60px;
    text-align: center;
  `,
  flyer: css`
    display: flex;
    justify-content: center;
    img {
      object-fit: contain;
    }
  `,
  button: css`
    width: 50px;
    height: 50px;
    background-color: ${colors.silver} !important;
    border-radius: 50%;
  `,
  modalContainer: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    background-color: #efefef;
    border-radius: 10px;
  `,
  modalTitleContainer: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: #efefef;
    padding: 24px 0px 20px 0px;
    border-bottom: 1px solid ${colors.silver};
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  `,
  closeButton: css`
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 24px;
  `,
};

export default styles;
